import React from 'react';
import {Route, Routes} from 'react-router-dom';
import HomePage from './components/home/homepage';

import {MobileMenuProvider} from './common/context/mobile-menu-context';
import Layout from "./components/layout/layout";
import About from "./components/about/about";
import Program from "./components/program/program";
import ContactMain from "./components/contact/v2/main/contact-main";
import PageTransition from "./v2/common/pageTransition";

const Routess = () => {
    return (

        <MobileMenuProvider>
            <PageTransition>
            <Routes>
                {/*<Route path="/" element={<HomePage />} />*/}
                <Route path="/" element={<HomePage/>}/>
                <Route path="/contact" element={<ContactMain/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path= "/Programes" element={<Program/>}/>
                <Route element={<Layout/>}>
                    {/*<Route path="/about" element={<About/>} />*/}
                    {/*<Route path="/" element={<HomePage />} />*/}
                    {/* Add other routes here */}
                </Route>
            </Routes>
            </PageTransition>
        </MobileMenuProvider>
    );
};

export default Routess;
